import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'yearFields']

  connect () {
    this.update()
  }

  update () {
    this.yearFieldsTarget.classList.toggle('hidden', this.checkboxTarget.checked)
  }
}
